
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 5c6.063 0 11 4.937 11 11v8c0 1.645-1.355 3-3 3h-3v-9h4v-2c0-4.983-4.017-9-9-9s-9 4.017-9 9v2h4v9H8c-1.645 0-3-1.355-3-3v-8C5 9.937 9.937 5 16 5zM7 20v4c0 .565.435 1 1 1h1v-5H7zm16 0v5h1c.565 0 1-.435 1-1v-4h-2z"}})])
          )
        }
      }
    